module.exports = __webpack_public_path__ + "img/hotel-8a.76397318.jpeg";